import { Suspense } from 'react';

import { TAccount } from '@helpers/Accounts/accounts.types';

import { useGetRepaymentsPanelData } from './useGetRepaymentsPanelData';
import MainContentPending from '../../../pageStructure/mainContentPending';
import RepayEarlyForFree from '../../OutstandingView/dashboardActions/RepayEarlyForFree/RepayEarlyForFree';
import FutureRepayments from '../futureRepayment/FutureRepayments';
import { OverduePayments } from '../overduePayments/OverduePayments';
import PastRepayments from '../pastRepayments/PastRepayments';
import { RCFNextRepayment } from '../RCFNextRepayment/RCFNextRepayment';
import { RCFRenewal } from '../RCFRenewal/RCFRenewal';
import { RepaymentsBeforeTopup } from '../repaymentsBeforeTopup/RepaymentsBeforeTopup';

export const RepaymentsPanel = ({
    accountId
}: {
    accountId: NonNullable<TAccount['account_id']>;
}) => {
    return (
        <Suspense fallback={<MainContentPending />}>
            <Repaymentswidgets accountId={accountId} />
        </Suspense>
    );
};

const Repaymentswidgets = ({
    accountId
}: {
    accountId: NonNullable<TAccount['account_id']>;
}) => {
    const { isOverdue, canTopUpAfterRepayments, isRBL, isMicroloan, isRCF } =
        useGetRepaymentsPanelData(accountId);

    if (isRCF)
        return (
            <div data-testid="rcf-repayments-panel" className="space-y-l">
                <RCFNextRepayment accountId={accountId} />
                <RepayEarlyForFree accountId={accountId} />
                <RCFRenewal />
            </div>
        );

    return (
        <div
            data-testid="repayments-panel"
            className="col-span-5 flex flex-col gap-l max-sm:col-span-full"
        >
            {canTopUpAfterRepayments && !isMicroloan && (
                <RepaymentsBeforeTopup accountId={accountId} />
            )}
            {!isRBL && <FutureRepayments accountId={accountId} />}
            <PastRepayments accountId={accountId} />
            {isOverdue ? (
                <OverduePayments accountId={accountId} />
            ) : (
                !isRBL && <RepayEarlyForFree accountId={accountId} />
            )}
        </div>
    );
};
